import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { IFeedbackRead } from 'modules/Candidates/typings';
import FeedbackCardsList from './partials/FeedbackCardsList';
import { KButton, KModalCard } from 'components';
import styles from './Feedback.module.scss';
import { deleteFeedback } from 'store/feedbacks/thunks';
import { useTranslation } from 'react-i18next';

interface IFeedbackProps {
  candidateId: string | null;
  feedbacks: IFeedbackRead[];
}

const Feedback: FC<IFeedbackProps> = ({
  candidateId,
  feedbacks,
}: IFeedbackProps) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [currentId, setCurrentId] = useState<string | null>(null);
  const dispatch = useDispatch();
  const url = `/candidates/${candidateId}/add-feedback`;

  const handleDelete = () => {
    if (!currentId) return;
    dispatch(deleteFeedback(currentId));
    setOpenModal(false);
  };

  const handleCloseModal = () => {
    setCurrentId(null);
    setOpenModal(false);
  };

  const { t } = useTranslation();

  return (
    <div className={styles.feedbacksContainer}>
      <KModalCard
        onClose={handleCloseModal}
        open={openModal}
        type={'confirmation'}
        confirmFn={handleDelete}
        confirmMsg={t(
          'You will not be able to recover this feedback!',
        )}
        confirmBtn={t('Delete')}
        setOpenModal={setOpenModal}
      />

      <Link className={styles.addFeedbackButton} to={url}>
        <KButton className={styles.addFeedbackButton}>
          {t('ADD FEEDBACK')}
        </KButton>
      </Link>

      <div className="feedback-container">
        <FeedbackCardsList
          feedbacks={feedbacks}
          setOpen={setOpenModal}
          setCurrentId={setCurrentId}
        />
      </div>
    </div>
  );
};
export default Feedback;
